import { OIDC_TOKEN_KEY } from '@feat-auth/auth.config';
import type { AxiosRequestConfig } from 'axios';

export const securityWorker = async (): Promise<AxiosRequestConfig> => {
  const token = localStorage.getItem(OIDC_TOKEN_KEY);
  return {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  };
};
